import React from "react";
import "./Latest_Card.css";
import { Link } from "react-router-dom";

const Latest_Card = ({ mediaContent = "<p>q</p>", description, name, link }) => {
  return (
    <section className="Latest_Card" >
      <Link to={link}>
        <div className="media_div">{mediaContent}</div>
        <div className="text_holder">
          <p className="bold_text">{name || " "} : </p>
          <p className="sub_text">{description || " "} </p>
        </div>
      </Link>
    </section>
  );
};

export default Latest_Card;
